import React, { Component, useState, PureComponent } from 'react';


import './assets/css/argon.css?v=1.0.0'
// import './assets/css/argon.min.css'
import './assets/vendor/@fortawesome/fontawesome-free/css/all.min.css'
import './assets/img/brand/favicon.png'
import './assets/vendor/nucleo/css/nucleo.css'
import './assets/css/custom.css'

// import {Dropdown,DropdownButton} from 'react'

import NavigationItems from './Components/NavigationItems'
import HeaderDashboard from './Components/HeaderDashboard'
import PageHeader from './Components/PageHeader'
import Footer from './Components/Footer'

// import { Link } from 'react-router-dom';
import axios from 'axios'
import Base from './Config'
import QuotationComponent from './Components/QuotationComponent';
import {
  Redirect
} from "react-router-dom";

import { Modal, ButtonToolbar, Button } from 'react-bootstrap';
import {
  WaveLoading,
} from 'react-loadingg';
// import 'bootstrap/dist/css/bootstrap.min.css';

import { NotificationContainer, NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import ToggleSwitch from './Components/ToggleSwitch';

function MyVerticallyCenteredModal(props) {
  const [done, setDone] = useState(false);
  const [value, setValue] = useState("");
  // console.log('props ',props);
  // console.log('props ',props['id']);
  // console.log('props ',props['status']);

  function worked() {
    console.log('worked');

    if (props['status'] == 4) {
      var bodyFormData = new FormData();
      bodyFormData.set('keyword', 'set_as_completed');
      bodyFormData.set('quotation_id', props['id']);
      bodyFormData.set('description', value);
      // console.log('quotation_id ', props['id']);
      // console.log('description ', value);
      // console.log('completed ');

      axios.patch(
        Base.url + 'Quotation/?is_paid=&status_id&is_completed&is_reopen=0',
        bodyFormData,
        {
          headers: {
            'Authorization': 'Token ' + localStorage.getItem('Token'),
          }
        }
      ).then(response => {
        console.log('Response :', response.data);
        if (response.data.Status) {
          setDone(true)
          console.log('status changed');

        }
        else { console.log('Error ', response.data.Error); }

      })
        .catch(error => {
          console.log('Error : ', error);
          NotificationManager.error('Error : ', error, 3000);
        })

    }
    else {
      var bodyFormData = new FormData();
      bodyFormData.set('keyword', 'change_status');
      bodyFormData.set('quotation_id', props['id']);
      bodyFormData.set('status_id', props['status']);
      bodyFormData.set('description', value);

      // console.log('qid ', props['id']);
      // console.log('stat ', props['status']);
      // console.log('desc ', value);

      axios.patch(
        Base.url + 'Quotation/?is_paid=&status_id&is_completed&is_reopen=0',
        bodyFormData,
        {
          headers: {
            'Authorization': 'Token ' + localStorage.getItem('Token'),
          }
        }
      ).then(response => {
        console.log('Response :', response.data);
        if (response.data.Status) {
          setDone(true)
          console.log('status changed');
          NotificationManager.success(response.data.Message, 'Success : ', 3000)


        }
        else {
          console.log('Error ', response.data.Error);
          NotificationManager.error('Error : ', response.data.Error, 3000);

        }

      })
        .catch(error => {
          console.log('Error : ', error);
          NotificationManager.error('Error : ', error, 3000);
        })


    }


  }

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      {/* {done?props.onHide:"flase"} */}
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {/* Are you sure ? */}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {done ?
          <h1 align={'center'}>Status changed </h1>
          :
          <>
            <h4>You are about to change quotation status to {props['status'] == 2 && 'Pending' || props['status'] == 3 && 'Scheduled' || props['status'] == 4 && 'Completed'}  </h4>
            <textarea className="form-control-lg" cols={70} placeholder="Your message"
              value={value} onChange={e => setValue(e.target.value)}
            >
            </textarea>
          </>
        }
        <br />
        {/* {
                done&&<Button onClick={props.onHide} variant="primary">ok</Button>
              } */}

      </Modal.Body>

      <Modal.Footer>
        {
          done ?
            <Button onClick={props.onHide, () => window.location.reload(true)} variant="primary">Close</Button>
            :
            <>
              <Button onClick={() => worked()} variant="success">Confirm</Button>
              <Button onClick={props.onHide} variant="danger">Cancel</Button>
            </>
        }
      </Modal.Footer>
    </Modal>
  );
}

class Items extends PureComponent {
  constructor() {
    super();
    // Initial state
    this.state = {
      open: false,
      modalShow: false,
      quotaionid: '',
      quotaionStatus: '',
      size: 1,
      notifyUser: false,
    };
  }

  // const [modalShow, setModalShow] = React.useState(false);
  // modalTrigger = () => {
  //   this.setState({ modalShow: true })
  //   console.log('woekd');
  // }
  timer() {
    this.setState({
      currentCount: this.state.currentCount - 1
    })
    if (this.state.currentCount < 1) {
      clearInterval(this.intervalId);
    }
  }

  // setInterval(() => {
  //   console.log('Interval triggered');
  // }, 1000);
  // setInterval=()=>(console.log('Interval triggered'), 1000);
  componentDidMount() {
    // this.interval = setInterval(() => {
    //   console.log("size : ",this.state.size)
    //   if (this.state.size>1) {
    //     this.setState({size: this.state.size - 1});        
    //   } else {
    //     this.setState({size: this.state.size + 1});
    //   }
    // }, 1000);
  }

  toggle() {
    // console.log('orid ',this.props.quotation.order.id);

    this.props.read(this.props.quotation.order.id)
    this.setState({
      open: !this.state.open,
    });
  }

  setStatus = (event) => {

    this.setState({
      modalShow: true,
      quotaionid: event.target.id,
      quotaionStatus: event.target.name,
    })

    console.log('worked id:', event.target.id);
    console.log('worked name:', event.target.name);
    // childSetStatus(event.target.id,event.target.status)


  }


  OnToggle(value, order_id) {
    console.log('param value', value)
    // console.log('state value', this.state.notifyUser,)

    this.setState({ notifyUser: value })
    // console.log("Order id .", order_id)
    // console.log('state value after setstate', this.state.notifyUser,)
    // return
    var fdata = new FormData();
    fdata.set('is_acknowledged', value)
    fdata.set('keyword', 'update_acknowledgement')
    fdata.set('order_id', order_id)

    for (var pair of fdata.entries()) {
      console.log(pair[0] + ', ' + pair[1]);
    }
    var config = {
      method: 'patch',

      url: Base.url + 'Order/',
      headers: {
        'Authorization': 'Token ' + localStorage.getItem('Token'),
      },
      data: fdata,

    };



    axios(config)
      .then(function (response) {
        console.log({ response })
        if (response.data.Status) {
          NotificationManager.success('', 'Success : ', 3000)
        } else {
          console.log(response.data.Message);
          NotificationManager.error('Error : ', response.data.Error, 3000)
        }
        //   this.props.refreshData()
        //   console.log(JSON.stringify(response.data));
      })
      .catch(function (error) {
        NotificationManager.error('Error : ', error, 3000)

        console.log(error);
      });
  }

  componentDidMount() {
    this.setState({ notifyUser: this.props.quotation.order.is_acknowledged })
  }

  render() {
    // console.log('filter found :',this.props.filter);
    // console.log('items',this.props.quotation.data);
    const quotation = this.props.quotation

    var date = new Date(quotation.date);
    // console.log("quotation : ",quotation);
    // console.log("is new : ",quotation.order.is_new);

    // console.log("username:",quotation.order.user_det.user.username);
    console.log({ quotation })

    console.log('state value after setstate', this.state.notifyUser,)

    return (
      <>

        <tr>
          <th scope="row">
            {quotation.order.is_new ? <><i className={`fa fa-1x fa-exclamation blink text-red `} > Unread</i><br /></> : ""}
            {/* new ? : {quotation.order.is_new?"true":"false"}<br/> */}
            <label className="opacity-5">{quotation.id}-&nbsp;</label>

            {quotation.order.service.name}
          </th>
          <td scope="row">{quotation.status.name}</td>
          <td>{date.toDateString()}</td>

          <td>{quotation.order.conv_day.day} </td>
          <td>{quotation.amount}</td>

          <td><button className="btn btn-sm" onClick={this.toggle.bind(this)}>{this.state.open ? <i className="fa fa-close text-red" ></i> : <i className="fa fa-info text-blue" ></i>}</button>

            <MyVerticallyCenteredModal
              show={this.state.modalShow}
              id={quotation.id}

              MakeQuotation={this.MakeQuotation}

              onHide={() => this.setState({ modalShow: false })}
            />
            {/* <div className="btn btn-sm" onClick={this.toggle.bind(this)}>{this.state.open?<i className="fa fa-close text-red" ></i>:<i className="fa fa-info text-blue" ></i>}</div> */}
          </td>

        </tr>
        {this.state.open ?
          <tr style={{ backgroundColor: 'rgb(231, 231, 231)' }}>
            {/* <td colSpan={1}>
                        <img height={70} width={100} src={quotation.photo} />
                    </td> */}
            <td colSpan={2}>
              <ToggleSwitch label={'Notify user'} value={this.state.notifyUser} onchange={(notifyUser) => this.OnToggle(notifyUser, quotation.order.id)} />

              User : {quotation.order.user_det.user.username}<br />
              Mobile : {quotation.order.user_det.mobile}<br />
              Date : {date.toDateString()} <br />
              {/* Transaction id :{quotation.payment?quotation.payment.transaction_id:'None'} <br /> */}
              Quatation Amount : {quotation.amount}<br />

              Status : {quotation.status.name}<br />
              {(quotation.status.id === 4) || (quotation.status.id === 5) ? '' :
                <>
                  <Button size="sm" id={quotation.id} name={2} onClick={this.setStatus} variant="danger">Pending</Button>
                  <Button size="sm" id={quotation.id} name={3} onClick={this.setStatus} variant="warning">Schedule</Button>
                  <Button size="sm" id={quotation.id} name={4} onClick={this.setStatus} variant="success">Complete</Button>
                </>
              }
              <br />
            </td>
            <td colSpan={2}>

              Description : <textarea readOnly className="form form-control" style={{ maxWidth: 250 }} value={quotation.description} ></textarea> <br />
              Expert openion : <textarea readOnly className="form form-control" style={{ maxWidth: 250 }} value={quotation.exp_opinion}></textarea>  <br />
              <ButtonToolbar>
                {/* <Button variant="primary" onClick={this.modalTrigger}>
                   Launch vertically centered modal
                 </Button> */}

                <MyVerticallyCenteredModal
                  show={this.state.modalShow}
                  id={this.state.quotaionid}
                  status={this.state.quotaionStatus}


                  onHide={() => this.setState({ modalShow: false })}
                />
              </ButtonToolbar>
            </td>
            <td colSpan={3}>
              {

                // console.log(data.payment),
                quotation.payment == null ?
                  // <img height='100' src={ImgNotPaid} />
                  "No Payement Details"


                  :
                  <>
                    Transaction id : {quotation.payment.transaction_id} <br />
                    Transaction date : {quotation.payment.transaction_date} <br />
                    Amount : {quotation.payment.amount} <br />
                    Payement Status : {quotation.payment.status} <br />
                  </>
              }

            </td>
          </tr>
          :
          <></>
        }
      </>
    )
  }
}


export default class Quotation extends Component {
  constructor(props) {
    super(props)
    this.state = {
      data: [],
      next: '',
      prev: '',
      filter: '',
      filterData: [],
      show: false,
      countQuotaion: 0,
      countPending: 0,
      countScheduled: 0,
      countCompleted: 0,
      countCancelled: 0,

      status_id: "",

      loading: true,
    }
  }
  loading = (arg) => {
    this.setState({
      loading: arg
    })
  }

  clearFilter = () => {
    this.loading(true)
    this.setState({
      status_id: ""
    })
  }



  componentDidMount() {
    // console.log('componentDidMount worked');

    this.fetchAllData()
  }

  fetchAllData = () => {
    axios.get(
      Base.url + 'Quotation/?is_paid&status_id=' + this.state.status_id + '&is_completed&is_reopen=0',
      {
        headers: {
          'Authorization': 'Token ' + localStorage.getItem('Token'),
        }
      }
    ).then(response => {
      console.log('Response :-', response.data.results);
      // console.log('Response data.results :',response.data.results);



      axios.get(
        Base.url + 'AdminDashboard/',
        {
          headers: {
            'Authorization': 'Token ' + localStorage.getItem('Token'),
          }
        }
      ).then(responseCount => {
        // console.log('Response C :',responseCount.data);
        // console.log('Response Normal :',responseCount.data.normal_qtns);


        let countQuotaion = responseCount.data.normal_qtns.on_qtn;
        let countPending = responseCount.data.normal_qtns.pending_qtn;
        let countScheduled = responseCount.data.normal_qtns.in_progress_qtn;
        // let countScheduled = response.data.results.filter(item => item.status.id ==3).length;
        let countCompleted = responseCount.data.normal_qtns.completed_qtn;
        let countCancelled = responseCount.data.normal_qtns.canceled_qtn;

        // console.log('Qu',countQuotaion);
        // console.log('Pe',countPending);
        // console.log('Sc',countScheduled);
        // console.log('Co',countCompleted);

        this.setState({
          data: response.data.results,
          next: response.data.next,
          prev: response.data.previous,
          countQuotaion: countQuotaion,
          countPending: countPending,
          countScheduled: countScheduled,
          countCompleted: countCompleted,
          countCancelled: countCancelled,
          loading: false,

        })

      })
        .catch(error => {
          console.log('Error loading quotation count: ', error);
          NotificationManager.error('Error : ', 'error', 3000);
        })
    })
      .catch(error => {
        //console.log('Error : ',error);
        NotificationManager.error('Error : ', 'error', 3000);
      })
  }

  next = () => {
    this.loading(true)
    //console.log('next ',this.state.next);

    axios.get(
      this.state.next.replace(/^http:\/\//i, 'https://'),
      {
        headers: {
          'Authorization': 'Token ' + localStorage.getItem('Token'),
        }
      }
    ).then(response => {
      //console.log('Response :',response.data);
      //console.log('Response data.results :',response.data.results);

      this.setState({
        data: response.data.results,
        next: response.data.next,
        prev: response.data.previous,
        loading: false,

      })
    })
      .catch(error => {
        //console.log('Error : ',error);
        NotificationManager.error('Error : ', error, 3000);
      })
  }


  prev = () => {
    this.loading(true)
    //console.log('next ',this.state.prev);

    axios.get(
      this.state.prev.replace(/^http:\/\//i, 'https://'),
      {
        headers: {
          'Authorization': 'Token ' + localStorage.getItem('Token'),
        }
      }
    ).then(response => {
      //console.log('Response :',response.data);
      //console.log('Response data.results :',response.data.results);

      this.setState({
        data: response.data.results,
        next: response.data.next,
        prev: response.data.previous,
        loading: false,

      })
    })
      .catch(error => {
        //console.log('Error : ',error);
        NotificationManager.error('Error : ', error, 3000);
      })
  }

  filterQuotation = (key) => {
    // console.log("filtering ",key)
    this.loading(true)
    // console.clear()
    // let data = [] 


    if (key == "onquotation") {

      this.setState({
        status_id: 1
      }, () => {
        this.fetchAllData()
      })
    }
    else if (key == 'pending') {
      this.setState({
        status_id: 2
      }, () => {
        this.fetchAllData()
      })
    }
    else if (key == 'scheduled') {
      this.setState({
        status_id: 3
      }, () => {
        this.fetchAllData()
      })
    }
    else if (key == 'cancelled') {
      this.setState({
        status_id: 5
      }, () => {
        this.fetchAllData()
      })
    }
    else {
      this.setState({
        status_id: 4
      }, () => {
        this.fetchAllData()
      })
    }
  }

  // static getDerivedStateFromProps(props, state) {
  //   var heroes = [
  //     {name: "Batman", franchise: "DC"},
  //     {name: "Ironman", franchise: "Marvel"},
  //     {name: "Thor", franchise: "Marvel"},
  //     {name: "Superman", franchise: "DC"}
  //   ];

  //   var marvelHeroes =  heroes.filter(function(hero) {
  //     return hero.franchise == "Marvel";
  //   });
  //   console.log('marvel heros ',marvelHeroes);
  //   return true
  // }

  setStatus = (id, status) => {
    // console.log('id and status ',id,":",status);
  }

  orderReadApi = (id) => {
    // console.log('read it',id);
    // console.log('filter ',this.state.filter);


    var bodyFormData = new FormData();
    bodyFormData.set('keyword', "set_as_read");
    bodyFormData.set('order_id_list', id);

    axios.patch(
      Base.url + 'Order/',
      bodyFormData,
      {
        headers: {
          'Authorization': 'Token ' + localStorage.getItem('Token'),
        }
      }
    )
      .then(response => {
        // console.log('response : ',response);
        if (response.data.Status) {
          // if(this.state.filter===false){
          this.fetchAllData()
          // console.log("call all");
          // }
          // else if(this.state.filter==="Outsiders"){
          //     this.fetchOutsiders()
          //     console.log("call outsider");
          // }
          // else{
          //     this.fetchTenant()
          //     console.log("call tenand");
          // }

          // console.log(response.data.Message);

        } else {
          // console.log(response.data.Message);

        }
      })
      .catch(error => {
        console.log(error);
      })
  }


  render() {

    // console.log('count completed :',this.state.countCompleted);
    // console.log('count completed :',this.state);


    return (
      <div>
        {/* <NotificationContainer/> */}

        <NavigationItems />
        <div className="main-content">
          <PageHeader pageName={'Quotation'} />

          <div className="header bg-gradient-primary pb-8 pt-5 pt-md-8">
            <div className="container-fluid">
              <div className="header-body">
                {/* Card stats */}
                <div className="row">

                  <QuotationComponent filterQuotation={() => this.filterQuotation('onquotation')} heading={'On quotation'} style={'fa fa-fw fa-circle text-blue'} count={this.state.countQuotaion} subHeading={'Quotation'} />
                  <QuotationComponent filterQuotation={() => this.filterQuotation('pending')} heading={'Pending'} style={'fa fa-fw fa-circle text-red'} count={this.state.countPending} subHeading={'Quotation'} />
                  <QuotationComponent filterQuotation={() => this.filterQuotation('scheduled')} heading={'Scheduled'} style={'fa fa-fw fa-circle text-yellow'} count={this.state.countScheduled} subHeading={'Quotation'} />
                  <QuotationComponent filterQuotation={() => this.filterQuotation('completed')} heading={'Completed'} style={'fa fa-fw fa-circle text-green'} count={this.state.countCompleted} subHeading={'Quotation'} />
                  <QuotationComponent filterQuotation={() => this.filterQuotation('cancelled')} heading={'Cancelled'} style={'fa fa-fw fa-circle text-black'} count={this.state.countCancelled} subHeading={'Quotation'} />

                </div>
              </div>
            </div>
          </div>

          {/* Page content */}
          <div className="container-fluid mt--7">
            <div className="row">

              {/* left main items */}
              <div className="col-xl-12 mb-5 mb-xl-0">
                <div className="card shadow">
                  <div className="card-header border-0">
                    <div className="row align-items-center">
                      <div className="col">
                        <h3 className="mb-0">{this.state.filter && <button className="btn btn-sm bg-translucent-secondary" onClick={this.clearFilter}>clear filter</button>} Quotations
                          {this.state.filter && <span className="text-muted text-sm">{' / ' + this.state.filter}</span>}
                        </h3>


                      </div>
                      <div className="col text-right">
                        {this.state.prev == null ? <button disabled={true} className="btn btn-sm btn-primary">Prev</button> : <button className="btn btn-sm btn-primary" onClick={this.prev}>Prev</button>}
                        {this.state.next == null ? <button disabled={true} className="btn btn-sm btn-primary">Next</button> : <button className="btn btn-sm btn-primary" onClick={this.next}>Next</button>}
                      </div>
                    </div>
                  </div>

                  <div className="table-responsive">
                    {this.state.loading ? <WaveLoading /> :
                      <table className="table align-items-center table-flush">
                        <thead className="thead-light">
                          <tr>
                            <th scope="col">Service Name</th>
                            <th scope="col">Status</th>
                            <th scope="col">Posted</th>
                            <th scope="col">Convenient day</th>
                            <th scope="col">Amount</th>
                            <th scope="col">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            this.state.data.map((item, index) => {
                              return <Items
                                childSetStatus={this.setStatus}
                                filter={this.state.filter}
                                key={index}
                                quotation={item}
                                read={this.orderReadApi}

                              />
                            })

                          }
                        </tbody>
                      </table>
                    }
                  </div>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>

    );
  }
}
